import { memo, useEffect, useMemo, useState } from "react";
import { ReactComponent as Info } from "../../../../assests/Info.svg";
import useIntl from "../../../../common/lang/locale/en-US";
import moment from "moment";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { useLoaderData, useLocation, useNavigate, useParams } from "react-router-dom";
import { saveData } from "..";
import ProfileIcon from "../../../../assests/IconSet.svg";
import SecTitle from "../../../../component/toptitlecomponent/SecTitle";
import { getParentPath, PageConfig, RM_PATH } from "../../../../configure/PathConfig";
import statusConfig from "../../../../configure/StatusConfig";
import { API_ROUTES, apiGet, apiPost } from "../../../../configure/apiConfig";
import {
  actionNameConfig,
  SocketIdType,
} from "../../../../configure/menuAndSubmenuConfig";
import { ContentWrapper, DescriptionText } from "../../../../globalStyles";
import { OverViewDetails } from "../../../../utils/dataformatter/OverView";
import { formatString } from "../../../../utils/dataformatter/Rawformatter";
// import useHasEditPermission from "../../../../utils/RbacUtils";
// import { PermittedItems } from "../../../../utils/RbacUtils";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import EllipsisTooltipCount from "@/components/ui/ellipsis-tooltip-count";
import { useToast } from "@/hooks/use-toast";
import { cn } from "@/lib/utils";
import { FloatingButtonContainer } from "@component/Buttons/FloatingButtonTailwind";
import { ExpandableOverviewCard } from "@component/cards/ExpandableOverviewCard";
import { StatusPipeline } from "@component/cards/StatusPipeline";
import { AdditionalInformation } from "@component/cards/AdditionalInformation";
import TextAreaCardTailwind from "@component/cards/TextAreaCardTailwind";
import NewCustomTable from "@component/table/NewCustomTable";
import { CircleX, Eye } from "lucide-react";
import { isQuillEmpty } from "@utils/index";
import siteConfig from "../../../../common/lang/locale/en-US";
import { getStatusText } from "@component/statusbadgestailwind/StatusBadge";
import { DESCRIPTIONCONFIG } from "@configure/label-config/describtionConfig";
import BackButton from "@/components/ui/backButton";
import { BACK_BUTTON_LABEL } from "@configure/label-config";
import { getPreviousTab } from "@configure/previousTab";
import useHasEditPermission from "@utils/RbacUtils";
import { ACCESSPERMISSION } from "@common/lang/locale/MenueditPath";
import { useNotesHandler } from "../hooks/useNotesHandler";
import { getBandLabel } from "@utils/bandFormatter";

const OverviewTab = ({ overviewDetails: overViewData, isRm, getData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [rmNote, setRMNote] = useState(overViewData?.rm_notes || "");
  
  const { toast } = useToast();
  const hasEditPermission  = useHasEditPermission(ACCESSPERMISSION.SCOPED_EDIT) || false;
  const isCollaborator = useLoaderData()?.data || false;
  const isAuthenticated = hasEditPermission && isCollaborator;
  
  const userName = useSelector((state) => state.currentUser?.currentUser?.name);
  const { projectid, dealstatus } = useParams();
  
  const navigate = useNavigate();
  
  const handleBeginPreliminary = useCallback(async () => {
    try {
      const response = await apiPost(
        API_ROUTES.UPDATE_STATUS_SCOPED_PROJECT,
        {
          projectId: projectid,
          status: "SCOPED_INPRG",
          updatedBy: userName,
        },
        null,
        {
          "Socket-Action": actionNameConfig.SCOPED.BEGIN_SCOPED_PROJECT,
          "Socket-Deal-Id": projectid,
          "Socket-Id-Type": SocketIdType.ProjectId,
          "Socket-Deal-Status": null,
        }
      );
      if (response) {
        toast({
          title: "Success",
          description: "Preliminary Staffing initiated successfully",
        });
        navigate(
          `${getParentPath() + PageConfig["PRELIMINARY"].REVIEW}/${formatString(
            getStatusText(statusConfig.SCOPEDINPRG, "contain"),
            "-"
          )}/${projectid}`,
          { replace: true }
        );
      }
    } catch (error) {
      console.log(error);
    }
  }, [projectid]);

    const linkWrapper = useCallback((value, isAuthenticated) => {
    if (overViewData?.prem_staffing_submitted === "Yes") {
      //   return (
      //     <CustomButton
      //       disabled={isButtonDisabled}
      //       type="link"
      //       id="BeginPreliminaryStaffing"
      //       className={`${
      //         isAuthenticated
      //           ? "cursor-pointer text-wavicale-primary"
      //           : "cursor-not-allowed text-gray-400"
      //       } !bg-transparent shadow-none text-md pl-0`}
      //       onClick={(e) => {
      //         if (!isAuthenticated) {
      //           e.preventDefault(); // 🔒 Prevent any default action
      //           return;
      //         }
      //         handleBeginPreliminary();
      //       }}
      //     >
      //       {value}
      //     </CustomButton>
      //   );
      // } else {
      return (
        <Button
          variant="text"
          onClick={() => setIsModalOpen(true)}
          id="btnopenpreliminarystaffingtable"
          className="text-wavicale-primary py-0 text-base h-0"
        >
          {value}
        </Button>
      );
    }
  }, []);

  const data = useMemo(
    () => OverViewDetails(overViewData, true, linkWrapper, isAuthenticated),
    [overViewData, linkWrapper]
  );
  
  const {
  note: scopedNote,
  error: notesError,
  touched: notesTouched,
  showSave: showSaveChanges,
  setTouched: setNotesTouched,
  handleNoteChange,
  handleSave: handleSaveNotes,
} = useNotesHandler(overViewData?.scoped_notes, projectid, data);

  let getRoleCardTableData = useCallback(async () => {
    try {
      const response = await apiGet(API_ROUTES.GET_ALL_PRELIMINARY_DETAILS, {
        projectId: projectid,
      });
      setTableData(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    getRoleCardTableData();
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "waviclerole",
        header: "Wavicle Role",
        // minSize: 10, //min size enforced during resizing
        maxSize: 80, //max size enforced during resizing
        Cell: ({ cell }) => {
          return cell?.getValue()?.role_name;
        },
      },
      {
        accessorKey: "location",
        header: "Location",
        maxSize: 60, //max size enforced during resizing
        editVariant: "select",
        editSelectOptions: ["Location 1", "Location 2"],
      },
      {
        accessorKey: "band_",
        header: "Band",
        // minSize: 10, //min size enforced during resizing
        maxSize: 40, //max size enforced during resizing
        editVariant: "select",
        editSelectOptions: ["Band 1", "Band 2"],
        Cell: ({ cell }) => getBandLabel(cell?.getValue()),
      },
      {
        accessorKey: "noofresources",
        header: "# Of Resources",
        // minSize: 10, //min size enforced during resizing
        maxSize: 60, //max size enforced during resizing
      },
      {
        accessorKey: "eststartdate",
        header: "Est Start Date",
        // minSize: 10, //min size enforced during resizing
        maxSize: 50, //max size enforced during resizing
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return moment(value).format(useIntl["staffing.date.format"]);
        },
        editVariant: "text",
      },
      {
        accessorKey: "estenddate",
        header: "Est End Date",
        // minSize: 10, //min size enforced during resizing
        maxSize: 50, //max size enforced during resizing
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return moment(value).format(useIntl["staffing.date.format"]);
        },
        editVariant: "text",
      },
      {
        accessorKey: "resources",
        header: "Potential Team Members",
        // minSize: 10, //min size enforced during resizing
        maxSize: 80, //max size enforced during resizing
        Cell: ({ cell }) => {
          const currentValue = cell?.getValue()?.map((item) => item?.fullname);
          // return <EllipsisTooltip title={currentValue}>{currentValue}</EllipsisTooltip>;
          return (
            <EllipsisTooltipCount
              count={currentValue?.length}
              title={currentValue?.[0] || "NA"}
              displayCount={currentValue?.length - 1}
              showDisplayCount={currentValue?.length > 1}
            >
              {(isOverflowed) => (
                <div className="flex flex-col gap-1">
                  {isOverflowed && (
                    <p className="text-xs font-sans dark:text-foreground">
                      {currentValue?.[0]}
                    </p>
                  )}
                  {currentValue?.slice(1)?.map((item, index) => (
                    <p
                      key={index}
                      className="text-xs font-sans dark:text-foreground"
                    >
                      {item}
                    </p>
                  ))}
                </div>
              )}
            </EllipsisTooltipCount>
          );
        },
      },
      {
        accessorKey: "skills",
        header: "Skills Required",
        // minSize: 10, //min size enforced during resizing
        maxSize: 50, //max size enforced during resizing
        editVariant: "select",
        editSelectOptions: ["Skill 1", "Skill 2"],
        Cell: ({ cell, column, renderedCellValue, row, table }) => {
          const value = cell.getValue();
          const formattedValue = value.map((item) => item.v_skill_name);
          if (!Array.isArray(cell?.getValue()) || cell.getValue().length === 0) {
            return 'NA';
          }

          return Array.isArray(value) ? (
            <EllipsisTooltipCount
              count={formattedValue?.length}
              title={formattedValue?.[0] || "NA"}
              displayCount={formattedValue?.length - 1}
              showDisplayCount={formattedValue?.length > 1}
            >
              {(isOverflowed) => (
                <div className="flex flex-col gap-1">
                  {isOverflowed && (
                    <p className="text-xs font-sans dark:text-foreground">
                      {formattedValue?.[0]}
                    </p>
                  )}
                  {formattedValue?.slice(1)?.map((item, index) => (
                    <p
                      key={index}
                      className="text-xs font-sans dark:text-foreground"
                    >
                      {item}
                    </p>
                  ))}
                </div>
              )}
            </EllipsisTooltipCount>
          ) : (
            value
          );
        },
      },
      {
        accessorKey: "utilization_",
        header: "Expected Util %",
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return `${value}%`;
        },
        maxSize: 50, //max size enforced during resizing
        editVariant: "text",
      },
    ],
    []
  );

  const isDisabled = useMemo(
    () => !isAuthenticated || overViewData?.prem_staffing_submitted === "Yes",
    [isAuthenticated, overViewData?.prem_staffing_submitted]
  );

  const url = useLocation().pathname;

  const isCompleted = url.includes(
    RM_PATH +
    PageConfig["RM"].PRELIMINARY +
    "/" +
    formatString(siteConfig["rm.resourceallocation.completed"])
  );
  const isPermissionDenied = !isAuthenticated || (overViewData?.hub_status === "SCOPED_CMPLT" || isCompleted);
  const pageDescription = overViewData?.hub_status === "SCOPED_CMPLT" ? DESCRIPTIONCONFIG.SCOPED_COMPLETED : DESCRIPTIONCONFIG.SCOPED_NEW;
  const pageBackButtonLabel = overViewData?.hub_status === "SCOPED_CMPLT" ? BACK_BUTTON_LABEL.SCOPED_COMPLETED : BACK_BUTTON_LABEL.SCOPED_NEW;
  return (
    <ContentWrapper>
      <BackButton label={pageBackButtonLabel} prevLocation={getPreviousTab('scoped',dealstatus.includes('completed') ? statusConfig.SCOPEDCMLPT :statusConfig.SCOPEDNEW)}/>
      <DescriptionText descriptionText={pageDescription} />
      {/* <Box sx={{ display: "flex", gap: 3.5, flexDirection: "column" }}> */}
      <ExpandableOverviewCard
        id="cardprojectoverview"
        data={data}
        label="projectDetail"
        status={isRm ? "SCOPED_CMPLT" : data?.status}
        title={data?.title}
        icon={ProfileIcon}
        variant="contain"
        isDefaultExpanded={true}
        model={isRm ? "RM" : data?.status}
        hubspot_url={data?.hubspot_url}
      />
      <StatusPipeline
        stages={data?.statusSection || []}
        isLoading={false}
      />

        <AdditionalInformation 
          data={data}
          isLoading={false}
          isAuthenticated={!isPermissionDenied}
          projectid={projectid}
          getData={getData}
        />

      <div className="flex flex-row justify-between w-full gap-[28px]">
        <div
          id="cardprojectdescription"
          className="bg-primary-foreground border border-card-border p-6 pb-7 rounded-2xl gap-4 w-1/2 flex flex-col"
        >
          <h3 className="text-sm font-semibold text-foreground">
            {useIntl["details.dealDescriptions"]}
          </h3>
          <TextAreaCardTailwind
            // title={useIntl["details.dealDescriptions"]}
            value={data?.dealDescription}
            key={"dealDescription"}
            disabled={true}
            headingClass={"text-xl"}
             className={`${isDisabled && "p-0 border-none rounded-none !bg-transparent"}`}
            // h="h-30"
            type={"formatter"}
            borderLine={true}
          />
        </div>
        <div
          id="cardeditnotes"
          className="bg-primary-foreground border border-card-border p-6 pb-7 rounded-2xl gap-4 w-1/2 flex flex-col"
        >
          <TextAreaCardTailwind
            onChange={handleNoteChange}
            onBlur={() => setNotesTouched(true)}
            id="editnotes"
            key={"editnotes"}
            title={useIntl["notes"]}
            // titleIcon={!isDisabled && <Info className="text-form-label" />}
            // titleIconText={!isDisabled ? "Add project notes as required":""}
            className={`bg-primary-foreground text-foreground ${isDisabled && "p-0 border-none rounded-none !bg-transparent"
              }`}
            type={"formatter"}
            borderLine={true}
            // error={notesError && notesTouched}
            disabled={isDisabled}
            value={isQuillEmpty(scopedNote) && isDisabled ? "NA" : scopedNote}
            // headingClass={"text-xl"}
            // h="h-50"
          />
        </div>
      </div>
      {overViewData?.prem_staffing_submitted === "Yes" && (
        <ContainerWrapper id="cardeditrmnotes">
          <TextAreaCardTailwind
            title={useIntl["preliminary_staffing_notes"]}
            id="editRMNotes"
            key={"editRMNotes"}
            onChange={setRMNote}
            type={"formatter"}
            className={`bg-primary-foreground text-foreground ${isDisabled && "p-0 border-none rounded-none !bg-transparent"
              }`}
            borderLine={true}
            disabled={overViewData?.prem_staffing_submitted === "Yes"}
            value={isQuillEmpty(rmNote) && isDisabled ? "NA" : rmNote}
            // headingClass={"text-xl"}
          />
        </ContainerWrapper>
      )}
      <Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <DialogContent className="max-w-6xl max-h-[90vh] overflow-y-auto [&_*]:!font-sans">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Eye className="!w-6 !h-6 text-primary" />
              <h4 className="text-md font-semibold w-[25ch] break-words">
                Preliminary Staffing
              </h4>
            </div>
            <Button
              id="modal-close"
              onClick={() => setIsModalOpen(false)}
              className="rounded-full bg-transparent p-0 h-auto shadow-none hover:bg-transparent"
            >
              <CircleX className="!w-6 !h-6 text-form-label" />
            </Button>
          </div>

          <NewCustomTable
            tableOptions={{
              coreProps: {
                columns: columns,
                data: tableData,
              },
              enableProps: {
                enableTopToolbar: false,
                enableBottomToolbar: false,
                enableEditing: false,
                enableRowActions: false,
              },
            }}
          />
        </DialogContent>
      </Dialog>
      <FloatingButtonContainer
        id="saveButton"
        isVisible={
          !isModalOpen &&
          overViewData?.prem_staffing_submitted === "No" 
        }
        isAuthenticated={isAuthenticated}
      >
        <Button disabled={!showSaveChanges} variant="outline" onClick={handleSaveNotes} id="saveButton">
          Save Changes
        </Button>
        <Button
          type="link"
          id="BeginPreliminaryStaffing"
          // disabled={showSaveChanges || notesError}
          disabled={showSaveChanges}
          onClick={(e) => {
            if (!isAuthenticated) {
              e.preventDefault(); // 🔒 Prevent any default action
              return;
            }
            handleBeginPreliminary();
          }}
        >
          Begin Preliminary Staffing
        </Button>
      </FloatingButtonContainer>
      {/* </Box> */}
    </ContentWrapper>
  );
};

export default memo(OverviewTab);

const ContainerWrapper = ({ children, className }) => {
  return (
    <div
      className={cn(
        `flex flex-col w-full  p-6 rounded-md gap-4 bg-primary-foreground border border-border`,
        className
      )}
    >
      {children}
    </div>
  );
};
